import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['5 volumi completi', '300 pagine nei volumi principali', '4 bonus professionali', '204 pagine nei bonus', '504 pagine complessive', 'Schede teoriche visuali', 'Attività operative', 'Laboratori', 'Verifiche A/B', 'Soluzioni per il docente', 'Giochi didattici', 'Progetti scientifici', 'Exit ticket e rubriche', 'Poster e tavole di consultazione', 'Download immediato', 'Materiali interamente in italiano', 'Pagamento unico', 'Nessun abbonamento', 'Garanzia di rimborso di 7 giorni'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-ink px-5 py-14 sm:py-24" data-id="element-54" data-mp="1n04utcc6jhaj">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-55" data-mp="1my1xs8cm0nwb">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-56" data-mp="3nrv6q1gc8g2p">
          Le tue lezioni organizzate. I tuoi studenti più coinvolti. Le tue settimane più leggere.
        </h2>
        <p className="mt-4 text-lg font-medium text-cobalt sm:text-xl" data-id="element-57" data-mp="3dx37kt73xl5t">
          CHIMICA VISIVA™ — Il sistema completo per insegnare chimica
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-58" data-mp="ae9x4p9mlcfv">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-59" data-mp="fdw8et5w8im1">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/20 text-cobalt" data-id="element-60" data-mp="gdn60sfcnjc">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-61" data-mp="5enj4dlz3s60" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-62" data-mp="2l6320dt4o9c1">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center" data-id="element-63" data-mp="2q6h0p58ua6xe">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-64" data-mp="wmp5q6gyz1ct">423 USD</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-cobalt sm:text-7xl" data-id="element-65" data-mp="ro44q4tw8dnb">
            27 USD
          </span>
        </div>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(22, 163, 74, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-cta-green px-6 py-4 text-base font-extrabold tracking-tight text-white shadow-lg shadow-cta-green/40 sm:text-lg" data-id="element-66" data-mp="mvaz7eqlp1a6">
          INIZIA A INSEGNARE CON CHIMICA VISIVA™
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-67" data-mp="20wgv2gxnh4k8">
          Accesso immediato · Pagamento unico · Disponibile in tutto il mondo · Garanzia di 7 giorni
        </p>
      </motion.div>
    </section>;
}